import { User } from '@brighte/passwordless-authenticator';
import { APPLICATION_SUBMITTED, PRIMARY_APPLICATION_SUBMITTED } from '../../utils';

export const getCongratulationMessage = (user?: User | null) => {
  return `Congratulations, ${user?.given_name ?? ''}!`;
};

export const getSubmittedPageTitle = (hasJoint: boolean, isJointForm: boolean) => {
  if (hasJoint || isJointForm) {
    return PRIMARY_APPLICATION_SUBMITTED;
  }
  return APPLICATION_SUBMITTED;
};
